import { Component, OnInit } from '@angular/core';
import { DirectorioComponent } from '../directorio/directorio.component';
import { UsuariosComponent } from '../usuarios/usuarios.component';
import { FuentesComponent } from '../directorio/fuentes/fuentes.component';
import { VariableschvComponent } from '../directorio/variableschv/variableschv.component';
import { VariablesfiviComponent } from '../directorio/variablesfivi/variablesfivi.component';

@Component({
  selector: 'app-administrador',
  templateUrl: './administrador.component.html',
  styleUrls: ['./administrador.component.css']
})
export class AdministradorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
